import type { AuthResponse, IsoDateTime, UserDto } from '@/shared/api/dto';

/** An authenticated session derived from the backend's AuthResponse. */
export interface Session {
  accessToken: string;
  tokenType: string;
  /** Access token expiry; the token is renewed shortly before. */
  expiresAt: IsoDateTime;
  /** When the sign-in session ends without a renewal (null for sessions without a refresh cookie). */
  sessionExpiresAt?: IsoDateTime | null;
  user: UserDto;
}

/** Where a session is kept: `local` survives browser restarts ("remember me"), `session` does not. */
export type SessionPersistence = 'local' | 'session';

/** Why the last session ended — lets the sign-in page explain what happened. */
export type SessionEndReason = 'signedOut' | 'expired';

export const toSession = (response: AuthResponse): Session => ({
  accessToken: response.accessToken,
  tokenType: response.tokenType,
  expiresAt: response.expiresAt,
  sessionExpiresAt: response.sessionExpiresAt ?? null,
  user: response.user,
});
